import React from 'react';
function IndentIncrease({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M19 10.22H11.2222M19 13.78H11.2222M19 6.67993H5M19 17.33H5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5.30566 9.5L7.80566 12L5.30566 14.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default IndentIncrease;
